import axios from "../utils/axios";

export const getProducts = async (productCategorySlug = false, page = 1) => {
    const { data } = await axios.get(`/products${productCategorySlug ? `/${productCategorySlug}` : ''}?page=${page}&per_page=16`);
    return data;
};

export const getProduct = async (productSlug) => {
    const { data } = await axios.get(`/product/${productSlug}`);
    return data;
};
export const getProductsCategories = async (page) => {
    const { data } = await axios.get(`/productCategory?page=${page}&per_page=500`);
    return data;
};

export const getProductsCategory = async (catSlug) => {
    const { data } = await axios.get(`/productCategory/${catSlug}`);
    return data;
};
